import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/assets";
import { Home, Bookmark, Film, Calendar, HelpCircle, Download, User, LogOut } from "lucide-react";

const nav = [
  { to: "/member", label: "Home", icon: Home, end: true },
  { to: "/member/videos", label: "Exclusive Videos", icon: Film },
  { to: "/member/events", label: "My Events", icon: Calendar },
  { to: "/member/saved", label: "Saved Content", icon: Bookmark },
  { to: "/member/resources", label: "Downloads", icon: Download },
  { to: "/member/questions", label: "Submit a Question", icon: HelpCircle },
  { to: "/member/account", label: "Account & Billing", icon: User },
];

export default function MemberLayout({ children }) {
  const { user, logout } = useAuth();
  const nav2 = useNavigate();
  const doLogout = async () => { await logout(); nav2("/"); };
  return (
    <div className="min-h-screen bg-cream-alt">
      <aside className="fixed top-0 left-0 w-64 h-screen bg-plum text-cream p-6 hidden lg:flex flex-col z-30">
        <Link to="/"><img src={LOGO_URL} alt="Judge Auntie Says" className="h-16 mb-6 w-auto object-contain" /></Link>
        <div className="text-xs uppercase tracking-widest text-gold mb-3">Member Portal</div>
        <nav className="flex flex-col gap-1">
          {nav.map(n => (
            <NavLink key={n.to} to={n.to} end={n.end} className={({isActive}) => `admin-sidebar-link ${isActive ? "active" : ""}`} data-testid={`member-nav-${n.to.replace(/\//g,"") || "home"}`}>
              <n.icon className="w-4 h-4" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="mt-auto pt-6 border-t border-cream/10">
          <div className="text-sm">{user?.name}</div>
          <div className="text-xs text-cream/60 truncate">{user?.email}</div>
          <button onClick={doLogout} className="mt-4 flex items-center gap-2 text-sm text-cream/70 hover:text-cream" data-testid="member-logout">
            <LogOut className="w-4 h-4" /> Sign out
          </button>
        </div>
      </aside>
      <div className="lg:ml-64 min-h-screen">
        <header className="bg-cream border-b border-gold-light lg:hidden">
          <div className="px-6 py-4 flex items-center justify-between">
            <Link to="/"><img src={LOGO_URL} className="h-12 w-auto object-contain" alt="Judge Auntie Says" /></Link>
            <button onClick={doLogout} className="text-sm text-plum" data-testid="member-logout-mobile">Sign out</button>
          </div>
        </header>
        <div className="lg:hidden bg-plum text-cream px-6 py-3 overflow-x-auto whitespace-nowrap">
          {nav.map(n => (
            <NavLink key={n.to} to={n.to} end={n.end} className={({isActive}) => `inline-block px-3 py-1.5 mr-2 rounded-full text-xs ${isActive ? "bg-gold text-plum" : "text-cream/80"}`}>
              {n.label}
            </NavLink>
          ))}
        </div>
        <main className="p-6 md:p-10 max-w-6xl">{children}</main>
      </div>
    </div>
  );
}
